<template>
  <div>
    <div class="md:flex justify-between mb-3 grid grid-cols-1">
      <img
        v-if="!featured"
        class="h-16"
        :src="getImg()"
        alt="shottracker logo"
      />

      <div class="my-auto md:text-right w-full">
        <p
          class="
            font-AvenirBlackFont
            text-gray-600
            hover:underline
            cursor-pointer
            inline-block
          "
          @click="openPressRelease"
        >
          Open press release
        </p>
        <p class="text-sm mb-3 font-AvenirBlackFont uppercase">
          For immediate release {{ file.JSON.date | formatDate }}
        </p>
      </div>
    </div>
    <p class="text-lg text-center font-AvenirBlackFont uppercase">
      {{ file.JSON.header }}
    </p>

    <img
      v-if="file.imageURL"
      class="mx-auto shadow-md rounded"
      :src="file.imageURL"
      alt="ShotTracker"
    />

    <p class="italic text-center font-QuestrialFont my-2">
      {{ file.JSON.subheader }}
    </p>

    <slot></slot>
  </div>
</template>

<script>
import "../../../utils/filters";
import { generateFullPath } from "../../../utils/fileHelpers";

export default {
  name: "PressReleaseDetails",

  props: {
    file: Object,
    featured: Boolean,
  },

  methods: {
    openPressRelease() {
      const { pdfURL, JSON } = this.file;
      const linkToOpen = pdfURL ? pdfURL : JSON.link;
      window.open(linkToOpen, "_blank");
    },

    getImg() {
      return generateFullPath("/images/logos/ShotTracker3_180.png");
    },
  },

  mounted() {
    this.$gtag.pageview({ page_title: this.file.JSON.header });
  },
};
</script>
